exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell_title{font-size:13px;font-weight:700}", ""]);

// exports
